import React, { useEffect, useRef, useState } from "react";
import AnimatedElement from "../animations/AnimatedElement";
import Prompts from "./Prompts";

function WelcomePanel() {
  const [isVisible, setIsVisible] = useState(false);
  const welcomeRef = useRef(null);

  const checkVisibility = () => {
    if (welcomeRef.current) {
      const rect = welcomeRef.current.getBoundingClientRect();
      const fullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      const partiallyVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (fullyVisible || partiallyVisible) {
        setIsVisible(true);
      }
    }
  };

  useEffect(() => {
    // Intersection Observer
    // const observer = new IntersectionObserver(
    //   ([entry]) => {
    //     if (entry.isIntersecting) {
    //       setIsVisible(true);
    //     }
    //   },
    //   { threshold: 0.5 }
    // );

    // if (welcomeRef.current) {
    //   observer.observe(welcomeRef.current);
    // }

    // Scroll Listener for Programmatic Scrolling
    window.addEventListener("scroll", checkVisibility);

    return () => {
      // if (welcomeRef.current) {
      //   observer.unobserve(welcomeRef.current);
      // }
      window.removeEventListener("scroll", checkVisibility);
    };
  }, []);

  return (
    <div
      ref={welcomeRef}
      className="flex flex-col justify-end items-center p-6 h-full bg-gradient-to-b from-gray-800 to-black"
    >
      {isVisible && (
        <>
          <div className="text-center mb-6">
            <h1 className="text-2xl font-semibold text-gray-200 mb-4">
              <AnimatedElement delay={0.1}>
                Hey! I'm SchoolLine's AI Agent
              </AnimatedElement>
            </h1>
            <p className="text-gray-400">
              Ask anything about SchoolLine, and we’ll guide you through!
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Prompts />
          </div>
        </>
      )}
    </div>
  );
}

export default WelcomePanel;